import { BaseWebComponentController } from '../../../../../framework/BaseWebComponentController';
import { templateProductTrialsOverlayWindowsApp } from '../view/template';
import { MspInProductTrialsOverlayWindowsAppWebComponent } from '../component/MspInProductTrialsOverlayWindowsAppWebComponent';
import { MspInProductTrialsOverlayWindowsAppView } from '../view/MspInProductTrialsOverlayWindowsAppView';
import { MspInProductTrialsOverlayWindowsAppRepository } from '../repository/MspInProductTrialsOverlayWindowsAppRepository';
import { MspInProductTrialsAdditionalUserSettings } from '../view/configs/msp-in-product-trials-overlay-window-config';

export class MspInProductTrialsOverlayWindowsAppController extends BaseWebComponentController {
  public component: MspInProductTrialsOverlayWindowsAppWebComponent;
  public view: MspInProductTrialsOverlayWindowsAppView;
  public viewConstructor: typeof MspInProductTrialsOverlayWindowsAppView;
  public dataRepository: MspInProductTrialsOverlayWindowsAppRepository;
  public dataRepositoryConstructor: typeof MspInProductTrialsOverlayWindowsAppRepository;

  constructor(component: MspInProductTrialsOverlayWindowsAppWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: MspInProductTrialsOverlayWindowsAppView,
      viewTemplate: templateProductTrialsOverlayWindowsApp,
      dataRepositoryConstructor: MspInProductTrialsOverlayWindowsAppRepository,
    });
  }

  async getDataForView(): Promise<MspInProductTrialsAdditionalUserSettings> {
    return await this.dataRepository.getAdditionalUserSettingsForInProductTrials();
  }
}
